import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "action",
  "use": "action-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"action\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0 1.314a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75zm0 4.5a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75zm.75 3.75a.75.75 0 000 1.5h14.5a.75.75 0 000-1.5H.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol